import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BalanceDetail from '../../Component/DashboardOne/BalanceDetail';
import ChartSmallCard from '../../Component/DashboardOne/ChartSmallCard';
import UserDetailcard from '../../Component/DashboardOne/UserDetailcard';
import PopupModal from '../../Component/Comman/PopupModal';
import { fetchDashboard, fetchWalletBalance } from '../../Redux/Actions/dataActions';
import { getActivePopups, markPopupAsViewed } from '../../services/popupService';

function Dashboard({ fetchDashboard, fetchWalletBalance, dashboard, wallet, auth }) {
    const [popups, setPopups] = useState([]);
    const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [viewedPopups, setViewedPopups] = useState(new Set());

    useEffect(() => {
        fetchDashboard();
        fetchWalletBalance();
        if (auth?.isAuthenticated && auth?.token) {
            fetchPopups();
        }
    }, [fetchDashboard, fetchWalletBalance, auth]);

    const fetchPopups = async () => {
        try {
            const response = await getActivePopups();
            if (response.success && response.data && response.data.length > 0) {
                const activePopups = Array.isArray(response.data) ? response.data : [];
                setPopups(activePopups);
                
                // Find first unviewed popup
                const firstUnviewedIndex = activePopups.findIndex(
                    popup => !viewedPopups.has(popup._id)
                );
                
                if (firstUnviewedIndex !== -1) {
                    setCurrentPopupIndex(firstUnviewedIndex);
                    setShowPopup(true);
                }
            }
        } catch (error) {
            console.error('Error fetching popups:', error);
        }
    };

    const handleMarkPopupViewed = async (popupId) => {
        try {
            await markPopupAsViewed(popupId);
            setViewedPopups(prev => new Set([...prev, popupId]));
            
            // Find next unviewed popup
            const nextUnviewedIndex = popups.findIndex(
                (popup, index) => index > currentPopupIndex && !viewedPopups.has(popup._id)
            );

            if (nextUnviewedIndex !== -1) {
                setCurrentPopupIndex(nextUnviewedIndex);
                setShowPopup(true);
            } else {
                setShowPopup(false);
            }
        } catch (error) {
            console.error('Error marking popup as viewed:', error);
            setShowPopup(false);
        }
    };

    const handleClosePopup = () => {
        // Find next unviewed popup
        const nextUnviewedIndex = popups.findIndex(
            (popup, index) => index > currentPopupIndex && !viewedPopups.has(popup._id)
        );

        if (nextUnviewedIndex !== -1) {
            setCurrentPopupIndex(nextUnviewedIndex);
            setShowPopup(true);
        } else {
            setShowPopup(false);
        }
    };

    return (
        <div className='container-xxl'>
            <UserDetailcard />
            <ChartSmallCard dashboardData={dashboard} />
            <BalanceDetail walletData={wallet} dashboardData={dashboard} />
            
            {/* Popup Modal */}
            {popups.length > 0 && popups[currentPopupIndex] && !viewedPopups.has(popups[currentPopupIndex]?._id) && (
                <PopupModal
                    popup={popups[currentPopupIndex]}
                    show={showPopup}
                    onClose={handleClosePopup}
                    onMarkViewed={handleMarkPopupViewed}
                    totalPopups={popups.length}
                    currentIndex={currentPopupIndex + 1}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({
    dashboard: state.data?.dashboard,
    wallet: state.data?.dashboard?.data?.wallet || state.data?.wallet,
    auth: state.auth,
});

export default connect(mapStateToProps, { fetchDashboard, fetchWalletBalance })(Dashboard);